import { styled } from '@mui/material/styles';
import { MuiGrid } from '../../../../../modules/material';
import Button from '../../library/Button';
import CircledIcon from '../../library/CircledIcon';

export const StyledButtonWrapper = styled(MuiGrid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
});

export const StyledButton = styled(Button)(({ theme }) => {
  return {
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      width: 'initial',
    },
  };
});

export const StyledCircledIcon = styled(CircledIcon)({
  marginRight: '12px',
});
